module.exports = __webpack_public_path__ + "static/media/chat-bubble.59e76d57.png";